import { BehaviorSubject, distinctUntilChanged, of, switchMap } from 'rxjs';
import StorageRepositoryFactory from '../../Storage/Application/Factories/StorageRepositoryFactory';
// @TODO: create this as a class, so the repositoryfactory can be injected
class CustomerCredentials {
  constructor() {
    this.validCredentials = new BehaviorSubject(false);
    this.credentialsKey = 'store-v4-access-token';
    /**
     * Try to return an observable of access token from storage, if it does not exist, try to get a new one using the refresh token if it fails it will return an empty string
     * This function does not follow hexagonal arquitecture, the implementation details will be moved to infrastructure if we have two implementations
     * @param samContext
     * @returns
     */
    this.getCredentials = samContext => {
      const storage = this.getStorage(samContext);
      const credentials = storage.get(this.credentialsKey);
      if (!credentials) {
        return this.refreshCredentials(storage);
      }
      return of(credentials);
    };
    /**
     *
     * It removes the credentials from the local storage & sets the observable to false
     */
    this.removeCredentials = samContext => {
      const storage = this.getStorage(samContext);
      storage.remove(this.credentialsKey);
      this.validCredentials.next(false);
    };
    /**
     *
     * It removes the credentials from the local storage & sets the observable to false
     */
    this.setCredentials = (samContext, credentials) => {
      const credentialsConfig = samContext.credentialsConfig.accessToken;
      const storage = this.getStorage(samContext);
      const oldCredentials = storage.get(this.credentialsKey);
      if (oldCredentials !== credentials) {
        storage.set(this.credentialsKey, credentials, credentialsConfig.expiration);
        this.validCredentials.next(true);
      }
    };
  }
  getStorage(samContext) {
    return StorageRepositoryFactory.resolve(samContext, {
      implementation: samContext.credentialsConfig.accessToken.implementation
    });
  }
  /**
   * This refresh-token is made up, this is just a dummy example and should not be taken as a valid example
   */
  refreshCredentials(storage) {
    const refresh_token = storage.get('refresh-token');
    if (refresh_token) {
      // call the refresh token endpoint and return the new token
      return of('');
    }
    return of('');
  }
  getValidCreadentials$(context) {
    return this.getCredentials(context).pipe(switchMap(token => {
      if (token) {
        this.validCredentials.next(true);
      }
      return this.validCredentials.pipe(distinctUntilChanged());
    }));
  }
}
export const customerCredentials = new CustomerCredentials();
